angular.module 'zc.projects'

.directive 'zcIncentiveStatus',  ($translate, $q, UniqueCouponCode) ->
  restrict: 'E'
  require: '?ngModel'
  scope:
    incentive: '='
  template: '<span ng-class="statusClass" tooltip="{{text}}"></span>'
  link: (scope, element, attrs) ->

    COUNT_THRESHOLD = 1 / 5

    return unless scope.incentive
    if scope.incentive.incentive_type == 'unique_coupon_code'
      query =
        projectId: scope.incentive.project_id
        incentiveId: scope.incentive.id
      $q.all [
        UniqueCouponCode.count(query)
        UniqueCouponCode.count(_.assignIn({ assigned: 1 }, query))
      ]
      .then ([totalCount, assignedCount]) ->
        unassignedCount = totalCount - assignedCount
        if scope.incentive.current_status is 'finished'
          scope.statusClass = 'fa fa-minus-circle'
          scope.text = $translate.instant('projectsIncentives.incentiveStatus.kigengire')
        else if totalCount is 0
          scope.statusClass = 'fa text-danger fa-exclamation-circle'
          scope.text = $translate.instant('projectsIncentives.incentiveStatus.kuuponkoodo_ga_touroku')
        else if unassignedCount is 0
          scope.statusClass = 'fa text-danger fa-times-circle'
          scope.text = $translate.instant('projectsIncentives.incentiveStatus.subete_no_kuuponkoodo')
        else if unassignedCount / totalCount < COUNT_THRESHOLD
          scope.statusClass = 'fa text-warning fa-exclamation-circle'
          scope.text = $translate.instant('projectsIncentives.incentiveStatus.kuuponkoodo_ga_nokori')
        else
          scope.statusClass = 'fa text-success fa-check-circle'
          scope.text = $translate.instant('projectsIncentives.incentiveStatus.koodo_wa_seijou')
    else
      switch scope.incentive.current_status
        when 'active'
          scope.statusClass = "fa fa-check-circle text-success"
          scope.text = $translate.instant('projectsIncentives.incentiveStatus.yuukou')
        when 'pending'
          scope.statusClass = 'fa fa-exclamation-circle text-warning'
          scope.text = $translate.instant('projectsIncentives.incentiveStatus.kigen_saki')
        when 'finished'
          scope.statusClass = 'fa fa-minus-circle'
          scope.text = $translate.instant('projectsIncentives.incentiveStatus.kigengire')
        else
          throw new Error("Invalid status! start_at: #{scope.incentive.start_at} end_at: #{scope.incentive.end_at}")



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.incentives/incentive_status.directive.coffee